export default __webpack_public_path__ + "static/media/534.26aa8dab.png";